var React = require('react');

function Spinner (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#A2CBFF","d":"M16 0a16 16 0 0 0 0 32 16 16 0 0 0 0-32m0 4a12 12 0 0 1 0 24 12 12 0 0 1 0-24","key":0}),React.createElement("path",{"d":"M16 0a16 16 0 0 1 16 16h-4A12 12 0 0 0 16 4z","key":1},React.createElement("animateTransform",{"attributeName":"transform","type":"rotate","from":"0 16 16","to":"360 16 16","dur":"0.8s","repeatCount":"indefinite"}))]);
}

Spinner.defaultProps = {"viewBox":"0 0 32 32","width":"32","height":"32","fill":"#3A66E5"};

module.exports = Spinner;

Spinner.default = Spinner;
